import { render, staticRenderFns } from "./CreateNotifyTeacher.vue?vue&type=template&id=48ae67bd&scoped=true"
import script from "./CreateNotifyTeacher.vue?vue&type=script&lang=js"
export * from "./CreateNotifyTeacher.vue?vue&type=script&lang=js"
import style0 from "./CreateNotifyTeacher.vue?vue&type=style&index=0&id=48ae67bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae67bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ae67bd')) {
      api.createRecord('48ae67bd', component.options)
    } else {
      api.reload('48ae67bd', component.options)
    }
    module.hot.accept("./CreateNotifyTeacher.vue?vue&type=template&id=48ae67bd&scoped=true", function () {
      api.rerender('48ae67bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifyTeacher/CreateNotifyTeacher.vue"
export default component.exports